import { isWeb } from "@memorang/helpers/platform";
import { Portal } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ProfileIcon from "./ChatUI/ProfileIcon";
import { FAB } from "./FAB";

type Props = {
	icon: string;
	label: string;
	onPress?: () => void;
};

export const AiFab = ({ icon, label, onPress }: Props) => {
	const insets = useSafeAreaInsets();
	const bottomBarHeight = isWeb ? 96 : 56;
	return (
		<Portal>
			<FAB
				icon={(_props) => <ProfileIcon uri={icon} />}
				label={label}
				style={{
					position: "absolute",
					bottom: insets.bottom + bottomBarHeight + 16,
					right: 16,
				}}
				onPress={onPress}
			/>
		</Portal>
	);
};
